module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <illustration show=true text=没有数据><p slot=title>说明文本说明文本说明文本</p> <p slot=desc>说明文本</p></illustration> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/illustration.vue
// module id = 162
// module chunks = 1